import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getReferralCodeFromUrl } from '@/utils/referralUtils';

/**
 * Hook to manage referral codes from URL parameters
 * Persists the referral code in session storage for the user's session
 */
export const useReferral = () => {
  const location = useLocation();
  const [referralCode, setReferralCode] = useState<string | undefined>();

  useEffect(() => {
    // Check URL for referral code
    const urlReferralCode = getReferralCodeFromUrl();
    
    if (urlReferralCode) {
      // Store in session storage so it persists during navigation
      sessionStorage.setItem('referralCode', urlReferralCode);
      setReferralCode(urlReferralCode);
    } else {
      // Check session storage for existing referral code
      const storedReferralCode = sessionStorage.getItem('referralCode');
      if (storedReferralCode) {
        setReferralCode(storedReferralCode);
      }
    }
  }, [location.search]);

  const clearReferralCode = () => {
    sessionStorage.removeItem('referralCode');
    setReferralCode(undefined);
  };

  return {
    referralCode,
    hasReferralCode: !!referralCode,
    clearReferralCode,
  };
};